export default {
  error: {
    fieldLengthMin: 'Zadajte aspoň 1 znak',
    fieldLengthMax: 'Prekročený maximálny počet znakov',
    nicknameAlreadySet: 'Alias používate',
    nicknameUsedByAnotherUser: 'Alias používa iný používateľ',
    blogAlreadySet: 'URL pre Blog už používate',
    invalidBlogUrl: 'Neplatná URL pre Blogy',
    topicNotFound: 'Diskusné vlákno nebolo nájdené',
    notLoggedIn: 'Používateľ nie je prihlásený',
    originNotAllowed: 'Doména nie je povolená',
    fieldMaxEmojis:
      'Váš príspevok prekročil maximálny počet emotikonov. Maximálny povolený počet je 10.',
  },
  postReport: {
    status: {
      reported: 'Nahlásený',
      accepted: 'Opodstatné',
      declined: 'Zamietnuté',
    },
    texts: {
      leadText:
        ' Všetky nahlásené príspevky prechádzajú cez kontrolu našich administrátorov. Ak vami nahlásený príspevok porušuje kódex diskutéra, čiže pravidlá diskusie, bude príspevok po overení skrytý. Ďakujeme, že sa podieľate na vytváraní kvalitných diskusií.',
    },
  },
  emailManagement: {
    menu: {
      topic: 'Diskusie k článku',
      post: 'Diskusné vlákna',
      subscribedUsers: 'Kto odoberá mňa',
      followers: 'Koho odoberám ja',
    },
    actions: {
      remove: 'Zmazať',
      unsubscribe: 'Zrušiť odber',
    },
    texts: {
      topic: 'Diskusie k článkom, ktoré odoberáte',
      post: 'Diskusné vlákna, ktoré odoberáte',
      subscribedUsers: 'Diskutéri, ktorých odoberáte',
      followers: 'Diskutéri, ktorí odoberajú moje príspevky',
      topicBlocked: 'Diskusia bola pozastavená',
      topicDeleted: 'Diskusia bola vymazaná',
    },
    pagination: {
      prev: 'Späť',
      next: 'Ďalej',
    },
    labels: {
      public: 'Verejné',
      private: 'Skryté',
      state: 'Stav',
      blogger: 'Blog',
      postCount: 'Počet príspevkov',
    },
  },
  profileManagement: {
    titles: {
      forum: 'Diskusie',
    },
    error: {
      fieldLengthMin: 'Zadajte aspoň 3 znaky',
      fieldLengthMax: 'Prekročený maximálny počet znakov',
      invalidUrl: 'Neplatná URL pre blogy',
    },
    labels: {
      firstActivityDate: 'Dátum prvej aktivity',
      lastActivityDate: 'Dátum poslednej aktivity',
      reportedPostsAll: 'Príspevky, ktoré som nahlásil: aktívne',
      reportedPostsAccepted: 'Príspevky, ktoré som nahlásil: zmazané',
      subscribedUsers: 'Odoberatelia',
      followers: 'Moji odoberatelia',
      public: 'Verejné',
      private: 'Skryté',
      contact: 'Kontakt',
      nickname: 'Alias',
      blogLink: 'Blog',
    },
    actions: {
      showMyPosts: 'Zobraziť všetky moje príspevky',
      newsletterManagement: 'Správa odberov diskusií',
      save: 'Uložiť',
      close: 'Zrušiť',
      edit: 'Upraviť',
      codexLink: 'Odkaz na Kódex diskutéra',
    },
    userChangeStatus: {
      requested: 'Čaká na schválenie',
      approved: 'Schválené',
      declined: 'Zamietnutá zmena',
    },
  },
  profile: {
    crossroads: {
      more: 'more',
      close: 'close',
      nickname: 'Profile',
      posts: 'My posts',
      discussionProfile: 'Diskusný profil',
      profile: 'My profile',
      followers: 'My followers',
      subscribers: 'Subscribed users',
      codex: 'Codex',
      codexAccompanyingText:
        'Pravidlá diskusií na SME.sk a povinnosti diskutujúceho',
      postRepliesUnseen: 'Nové reakcie na moje príspevky',
    },
    labels: {
      postReplies: 'Všetky reakcie',
      postRepliesUnseen: 'Nové reakcie',
      postRepliesUnseenMenu: 'Reakcie',
      new: 'Nové',
      profile: 'Profil',
      banned:
        'Z dôvodu porušenia kódexu diskutéra bolo vaše diskusné konto zablokované. Do diskusií SME.sk teraz nemôžete prispievať.',
      nickname: 'Nickname',
      subscribers: 'Odoberám',
      subscribersVisitor: 'Koho diskutér odoberá',
      followers: 'Kto ma odoberá',
      followersVisitor: 'Kto odoberá diskutéra',
      posts: 'Príspevky',
      postsVisitor: 'Príspevky',
      postsVisitorAll: 'Príspevky',
      myProfile: 'Môj profil',
      blocked: 'Porušenie kódexu',
      lastActivity: 'Posledná aktivita',
      postCount: 'Počet príspevkov',
      reportedPosts: 'Nahlásené',
      blackList: 'Blacklist',
      public: 'verejný',
      private: 'súkromný',
      firstActivityDate: 'Dátum prvej aktivity',
      lastActivityDate: 'Dátum poslednej aktivity',
      email: 'E-mail',
      blogger: 'Blog',
      rules: 'Pravidlá diskusií',
      followersText1: 'Zoznam svojich odberateľov je nastavený ako',
      followersText2: 'Zmeniť si to môžete v',
      subscribersText1: 'Zoznam svojich odberateľov je nastavený ako',
      subscribersText2: 'Zmeniť si to môžete v',
      user: 'Používateľ',
      action: 'Akcia',
    },
    actions: {
      codex: 'Kódex diskutujúceho',
      loadNext: 'Načítať ďalšie',
      remove: 'Zmazať',
      removeSubscriber: 'Zrušiť odber používateľa',
      unsubscribe: 'Zrušiť odber',
      visitProfile: 'Navštíviť profil',
      profileDetail: 'Detail profilu',
      cancelBlocking: 'Zrušiť blokovanie',
      subscribeUser: 'Odoberať používateľa',
      editProfile: 'Upraviť profil',
      blockUser: 'Blokovať',
      removeBlockedUser: 'Zrušiť Blokovanie',
      more: 'Viac',
      followersTextProfile: 'SME profile',
      subscribersTextProfile: 'SME profile',
    },
    actionResults: {
      subscribed: 'Začali ste odoberať tento príspevok',
      alreadySubscribed: 'Používateľa už odoberáte',
    },
    other: {
      loadingFollowers: 'Načítavam...',
      loadingSubscribers: 'Načítavam...',
      loadingBlacklist: 'Načítavam...',
      loadingBannedUsers: 'Načítavam...',
    },
  },
  post: {
    actions: {
      backToArticle: 'Spať na článok',
      copyLink: 'Kopírovať odkaz',
      share: 'Zdieľať',
      vote: 'Hlasovať',
      respond: 'Reagovať',
      respondButton: 'Uverejniť',
      closeButton: 'Zrušiť',
      subscribe: 'Odoberať',
      loadBefore: 'Načítať predchádzajúce',
      loadNext: 'Načítať ďalšie',
      loadNextPluralized:
        'Zobraziť ďalších {count} príspevkov|Zobraziť ďalší {count} príspevok|Zobraziť ďalšie {count} príspevky|Zobraziť ďalšie {count} príspevky|Zobraziť ďalšie {count} príspevky|Zobraziť ďalších {count} príspevkov',
      detail: 'Detail diskusie',
      show: 'Zobraziť',
      showCreatedPost: ' Zobraziť príspevok.',
      report: 'Nahlásiť',
      copy: 'Kopírovať',
      article: 'Článok:',
      showInThread: 'Zobraziť vo vlákne',
      goToDiscussion: 'Prejsť do diskusie',
      subscribeTopic: 'Odoberať diskusiu',
      subscribeUser: 'Odoberať diskutéra',
      allPosts: 'Všetky príspevky',
      allPostsShort: 'Všetky',
      showAllPosts: 'Zobraziť všetky reakcie',
      hideAllPosts: 'Skryť všetky reakcie',
      more: 'Viac',
      showFullPost: '... celý príspevok',
    },
    menu: {
      best: 'Najobľúbenejšie',
      newest: 'Najnovšie',
      oldest: 'Najstaršie',
    },
    labels: {
      discussion: 'Diskusia',
      modalTitle: 'Reagujete na príspevok',
      editModalTitle: 'Editing post',
    },
    actionResults: {
      reportedConfirmation: 'Je príspevok nevhodný?',
      reportedConfirmationText: 'Áno, príspevok porušuje',
      reportedConfirmationCodex: 'Kódex diskutéra',
      reportedConfirmationAction: 'Nahlásiť príspevok',
      copied: 'Odkaz je skopírovaný',
      alreadyVotedStart: 'Už ste,',
      alreadyVotedStrong: 'vyjadrili svoj názor.',
      alreadyVotedEnd: 'Ďakujeme.',
      changed: 'Váš hlas sme zmenili.',
      votedStrong: 'Ďakujeme',
      votedEnd: ', že ste prejavili svoj názor.',
      reported: 'Nahlásené porušenie kódexu.',
      alreadyReported: 'Príspevok už bol nahlásený.',
      subscribed: 'Pridané do odberov',
      alreadySubscribed: 'Príspevok už odoberáte',
      alreadySubscribedText: 'Prajete si odoberať aj tohto používateľa?',
      postResponded: 'Vaša reakcia bola pridaná na koniec diskusie.',
      topicAlreadySubscribed: 'Diskusiu už odoberáte',
      topicSubscribed: 'Diskusia pridaná do odberov',
    },
    forms: {
      subscribeTopic: 'Odoberať notifikácie na celú diskusiu',
      subscribePost: 'Odoberať notifikácie na reakcie na tento príspevok',
      textareaPlaceholder: ', napíšte svoj komentár...',
    },
    texts: {
      bannedTooltipHeader: 'Porušenie kódexu',
      bannedHeader: 'Porušili ste kódex diskutéra',
      banned:
        'Z dôvodu porušenia kódexu diskutéra bolo vaše diskusné konto zablokované. Do diskusií SME.sk teraz nemôžete prispievať.',
      postCountText:
        'príspevkov|príspevok|príspevky|príspevky|príspevky|príspevkov',
      loginHeading:
        'Ak chcete prispievať do diskusie, musíte byť prihlásený predplatiteľ.',
      loginBanner: 'Ak chcete pridať reakciu do diskusie musíte byť',
      loginLink: 'prihlásený',
      loginBtnText: 'Prihlásiť sa',
      loginText: 'Máte predplatné na inom účte?',
      loginTextLink: 'Prihláste sa s ním.',
      subscribeHeading: 'Prispievať do diskusie môžu len predplatitelia.',
      topicBlocked: 'Pridávanie príspevkov do diskusie bolo zablokované.',
      subscribeBuy: 'Kúpiť predplatné',
      subscribeBanner: 'Reagovať môžu len platiaci používatelia.',
      newPostFrom: 'Nový príspevok od',
      addPost: 'Pridať reakciu',
      blocked: 'Zablokovaný príspevok.',
      gdprBlocked: 'Zablokovaný príspevok z dôvodu porušenia GDPR.',
      blockedParent: 'Reagujete na zablokovaný príspevok.',
      ipAddress: 'IP:',
      topicNotFound: 'Diskusné vlákno nebolo nájdené',
      gdprBlockedParent:
        'Reagujete na príspevok ktorý bol zablokovaný z dôvodu porušenia GDPR.',
      contentAuthorReplies: ' zareagoval',
      contentAuthorReportedText: 'Nahlásili ste prispevok diskutéra ',
    },
    other: {
      today: 'Dnes',
      singsNumber: 'Počet znakov',
      singsNumberOverrun: 'Prekročený počet znakov: ',
      loadingPosts: 'Načítavajú sa príspevky...',
      violationReasonText: 'Dôvod:',
    },
  },
}
